// extracted by mini-css-extract-plugin
export default {"imageContainer":"jna-z","summaryPar":"kna-z","ratingCategories":"lna-z","reviewerInfo":"mna-z","reviewTypes":"nna-z","expanded":"ona-z"};